/**
 * countyToMetro:
 * A generic mapping of U.S. county and state pairs to their major metropolitan area names.
 */
export const countyToMetro = {
  // New York City Metro
  "New York County, NY": "New York City",
  "Kings County, NY": "New York City",
  "Queens County, NY": "New York City",
  "Bronx County, NY": "New York City",
  "Richmond County, NY": "New York City",

  // Boston Metro
  "Suffolk County, MA": "Boston",
  "Norfolk County, MA": "Boston",
  "Middlesex County, MA": "Boston",
  "Essex County, MA": "Boston",
  "Plymouth County, MA": "Boston",
  "Worcester County, MA": "Boston",

  // Providence Metro
  "Providence County, RI": "Providence",
  "Bristol County, RI": "Providence",
  "Kent County, RI": "Providence",

  // Portland, ME Metro
  "Cumberland County, ME": "Portland",
  "York County, ME": "Portland",

  // Los Angeles Metro
  "Los Angeles County, CA": "Los Angeles",
  "Orange County, CA": "Los Angeles",
  "Ventura County, CA": "Los Angeles",
  "Riverside County, CA": "Los Angeles",
  "San Bernardino County, CA": "Los Angeles",

  // Chicago Metro
  "Cook County, IL": "Chicago",
  "DuPage County, IL": "Chicago",
  "Lake County, IL": "Chicago",
  "Will County, IL": "Chicago",

  // Philadelphia Metro
  "Philadelphia County, PA": "Philadelphia",
  "Montgomery County, PA": "Philadelphia",
  "Bucks County, PA": "Philadelphia",
  "Delaware County, PA": "Philadelphia",

  // Dallas–Fort Worth Metro
  "Dallas County, TX": "Dallas–Fort Worth",
  "Tarrant County, TX": "Dallas–Fort Worth",

  // Miami Metro
  "Miami-Dade County, FL": "Miami",
  "Broward County, FL": "Miami",
  "Palm Beach County, FL": "Miami",

  // Houston Metro
  "Harris County, TX": "Houston",
  "Fort Bend County, TX": "Houston",
  "Montgomery County, TX": "Houston",

  // Washington, D.C. Metro
  "Washington County, DC": "Washington, D.C.",
  "Arlington County, VA": "Washington, D.C.",
  "Fairfax County, VA": "Washington, D.C.",
  "Prince George's County, MD": "Washington, D.C.",
  "Alexandria City, VA": "Washington, D.C.",

  // San Francisco Bay Area Metro
  "San Francisco County, CA": "San Francisco Bay Area",
  "Marin County, CA": "San Francisco Bay Area",
  "Alameda County, CA": "San Francisco Bay Area",
  "Contra Costa County, CA": "San Francisco Bay Area",
  "San Mateo County, CA": "San Francisco Bay Area",
  "Santa Clara County, CA": "San Francisco Bay Area",
  "Solano County, CA": "San Francisco Bay Area",

  // Seattle Metro
  "King County, WA": "Seattle",
  "Snohomish County, WA": "Seattle",
  "Pierce County, WA": "Seattle",
  "Kitsap County, WA": "Seattle",

  // Additional metros can be added here
};

/**
 * stateNameToCode:
 * Mapping of U.S. state full names to their two-letter postal codes.
 */
export const stateNameToCode = {
  Alabama: "AL",
  Alaska: "AK",
  Arizona: "AZ",
  Arkansas: "AR",
  California: "CA",
  Colorado: "CO",
  Connecticut: "CT",
  Delaware: "DE",
  Florida: "FL",
  Georgia: "GA",
  Hawaii: "HI",
  Idaho: "ID",
  Illinois: "IL",
  Indiana: "IN",
  Iowa: "IA",
  Kansas: "KS",
  Kentucky: "KY",
  Louisiana: "LA",
  Maine: "ME",
  Maryland: "MD",
  Massachusetts: "MA",
  Michigan: "MI",
  Minnesota: "MN",
  Mississippi: "MS",
  Missouri: "MO",
  Montana: "MT",
  Nebraska: "NE",
  Nevada: "NV",
  "New Hampshire": "NH",
  "New Jersey": "NJ",
  "New Mexico": "NM",
  "New York": "NY",
  "North Carolina": "NC",
  "North Dakota": "ND",
  Ohio: "OH",
  Oklahoma: "OK",
  Oregon: "OR",
  Pennsylvania: "PA",
  "Rhode Island": "RI",
  "South Carolina": "SC",
  "South Dakota": "SD",
  Tennessee: "TN",
  Texas: "TX",
  Utah: "UT",
  Vermont: "VT",
  Virginia: "VA",
  Washington: "WA",
  "West Virginia": "WV",
  Wisconsin: "WI",
  Wyoming: "WY",
};
